import React, { useState, useEffect } from 'react';
import CourseCard from './courseCard';
import Empty from './empty';
import styles from './styles.scss';
import { getCourses, ICoursesData } from '@services/my-home';
import moment from 'moment';
import { useTranslation } from 'hooks/use-translation';

/**
 * 课程页面
 */
export default function CoursesView() {
	const { transData } = useTranslation('perfilAndAjustes');

	const [pendingList, setPendingList] = useState<ICoursesData[]>([]); // 待完成课程
	const [finishList, setFinishList] = useState<ICoursesData[]>([]); // 已完成课程
	const [isEmpty, setIsEmpty] = useState(false); // 空状态
	const [isMore, setIsMore] = useState(false); // 待完成课程 是否超过四节
	const monthData = transData.monthData;

	const getList = async (lessonState: number) => {
		//lessonState:  0 待上课 1 已上课
		return await getCourses({ pageNo: 1, pageSize: 99999, lessonState });
	};

	useEffect(() => {
		// 待上课
		getList(0).then((res: any) => {
			const { code, data } = res;
			if (code === '0') {
				const list = data?.lessonCardList || [];
				setIsMore(list.length > 4);
				setPendingList(list);
			} else {
				setIsMore(false);
				setPendingList([]);
			}
		});
	}, []);

	useEffect(() => {
		// 已上课
		getList(1).then((res: any) => {
			const { code, data } = res;
			if (code === '0') {
				const list = data?.lessonCardList || [];
				let dateStr = '';
				list.forEach((item: ICoursesData) => {
					const currentDateStr = moment(item.lessonStartTime).format('YYYY-MM');
					if (dateStr !== currentDateStr) {
						dateStr = currentDateStr;
						const strList = currentDateStr.split('-');
						item['customDateStr'] = `${monthData[strList[1] as keyof typeof monthData]} , ${strList[0]}`;
					}
				});
				setFinishList(list);
			} else {
				setFinishList([]);
			}
		});
	}, []);

	useEffect(() => {
		if (pendingList.length && finishList.length) {
			setIsEmpty(false);
		} else {
			setIsEmpty(false);
		}
	}, [pendingList, finishList]);

	const isEmptyList = (list: unknown[]) => {
		return list.length === 0;
	};

	const onClickMore = () => {
		setIsMore(false);
	};

	return (
		<div className={styles.ac_course_warp}>
			{isEmpty && <Empty />}
			{!isEmpty && (
				<>
					{/* 未完成课程 */}
					<div className={styles.title_warp}>
						<h3 className={styles.title}>{transData.pendingCourses}</h3>
						{isMore && (
							<span className={styles.right_more} onClick={onClickMore}>
								{transData.more}
							</span>
						)}
					</div>

					{isEmptyList(pendingList) && <Empty />}

					{!isEmptyList(pendingList) && (
						<div className={styles.card_content}>
							<div className={styles.card_box}>
								{isMore &&
									pendingList.slice(0, 4).map((item, i) => (
										<div className={styles.card_item_box} key={i}>
											<CourseCard {...item} />
										</div>
									))}

								{!isMore &&
									pendingList.map((item, i) => (
										<div className={styles.card_item_box} key={i}>
											<CourseCard {...item} />
										</div>
									))}
							</div>
						</div>
					)}

					{isMore && (
						<div className={styles.more_warp}>
							<span onClick={onClickMore}>{transData.more}</span>
						</div>
					)}

					{/* 已完成课程 */}
					<div className={styles.title_warp}>
						<h3 className={styles.title}>{transData.coursesFinished}</h3>
					</div>

					{isEmptyList(finishList) && <Empty />}

					{!isEmptyList(finishList) && (
						<div className={`${styles.finish_box} ${styles.card_content} ${styles.card_box}`}>
							{finishList.map((item, i) => (
								<div className={`${styles.card_item_box} ${i % 2 !== 0 && item.customDateStr ? styles.block : ''}`} key={i}>
									{item.customDateStr && <h6 className={styles.subhead}>{item.customDateStr}</h6>}
									<CourseCard {...item} />
								</div>
							))}
						</div>
					)}
				</>
			)}
		</div>
	);
}
